<app-form>
  <app-reset-password-form></app-reset-password-form>
</app-form>